/* tslint:disable */
/* eslint-disable */
/**
 * Real Estate CRM Web API
 * API endpoints for web application
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CategoryStatisticsDto } from '../models';
// @ts-ignore
import { CreateUnitCategoryCommand } from '../models';
// @ts-ignore
import { UnitBriefDto } from '../models';
// @ts-ignore
import { UnitCategoryBasicInfoDto } from '../models';
// @ts-ignore
import { UnitCategoryDtoPaginatedList } from '../models';
// @ts-ignore
import { UnitCategoryFloorDto } from '../models';
// @ts-ignore
import { UpdateUnitCategoryCommand } from '../models';
/**
 * UnitCategoriesApi - axios parameter creator
 * @export
 */
export const UnitCategoriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {number} [projectId] 
         * @param {string} [searchTerm] 
         * @param {boolean} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitCategoriesGet: async (pageNumber?: number, pageSize?: number, projectId?: number, searchTerm?: string, isActive?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/UnitCategories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['ProjectId'] = projectId;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['SearchTerm'] = searchTerm;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['IsActive'] = isActive;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitCategoriesIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUnitCategoriesIdDelete', 'id', id)
            const localVarPath = `/api/UnitCategories/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitCategoriesIdFloorsGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUnitCategoriesIdFloorsGet', 'id', id)
            const localVarPath = `/api/UnitCategories/{id}/floors`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitCategoriesIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUnitCategoriesIdGet', 'id', id)
            const localVarPath = `/api/UnitCategories/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateUnitCategoryCommand} [updateUnitCategoryCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitCategoriesIdPut: async (id: number, updateUnitCategoryCommand?: UpdateUnitCategoryCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUnitCategoriesIdPut', 'id', id)
            const localVarPath = `/api/UnitCategories/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUnitCategoryCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitCategoriesIdStatisticsGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUnitCategoriesIdStatisticsGet', 'id', id)
            const localVarPath = `/api/UnitCategories/{id}/statistics`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitCategoriesIdUnitsGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUnitCategoriesIdUnitsGet', 'id', id)
            const localVarPath = `/api/UnitCategories/{id}/units`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateUnitCategoryCommand} [createUnitCategoryCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitCategoriesPost: async (createUnitCategoryCommand?: CreateUnitCategoryCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/UnitCategories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUnitCategoryCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UnitCategoriesApi - functional programming interface
 * @export
 */
export const UnitCategoriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UnitCategoriesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {number} [projectId] 
         * @param {string} [searchTerm] 
         * @param {boolean} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUnitCategoriesGet(pageNumber?: number, pageSize?: number, projectId?: number, searchTerm?: string, isActive?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnitCategoryDtoPaginatedList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUnitCategoriesGet(pageNumber, pageSize, projectId, searchTerm, isActive, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUnitCategoriesIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUnitCategoriesIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUnitCategoriesIdFloorsGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UnitCategoryFloorDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUnitCategoriesIdFloorsGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUnitCategoriesIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnitCategoryBasicInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUnitCategoriesIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateUnitCategoryCommand} [updateUnitCategoryCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUnitCategoriesIdPut(id: number, updateUnitCategoryCommand?: UpdateUnitCategoryCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUnitCategoriesIdPut(id, updateUnitCategoryCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUnitCategoriesIdStatisticsGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoryStatisticsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUnitCategoriesIdStatisticsGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUnitCategoriesIdUnitsGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UnitBriefDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUnitCategoriesIdUnitsGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateUnitCategoryCommand} [createUnitCategoryCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUnitCategoriesPost(createUnitCategoryCommand?: CreateUnitCategoryCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUnitCategoriesPost(createUnitCategoryCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UnitCategoriesApi - factory interface
 * @export
 */
export const UnitCategoriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UnitCategoriesApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {number} [projectId] 
         * @param {string} [searchTerm] 
         * @param {boolean} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitCategoriesGet(pageNumber?: number, pageSize?: number, projectId?: number, searchTerm?: string, isActive?: boolean, options?: any): AxiosPromise<UnitCategoryDtoPaginatedList> {
            return localVarFp.apiUnitCategoriesGet(pageNumber, pageSize, projectId, searchTerm, isActive, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitCategoriesIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiUnitCategoriesIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitCategoriesIdFloorsGet(id: number, options?: any): AxiosPromise<Array<UnitCategoryFloorDto>> {
            return localVarFp.apiUnitCategoriesIdFloorsGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitCategoriesIdGet(id: number, options?: any): AxiosPromise<UnitCategoryBasicInfoDto> {
            return localVarFp.apiUnitCategoriesIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateUnitCategoryCommand} [updateUnitCategoryCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitCategoriesIdPut(id: number, updateUnitCategoryCommand?: UpdateUnitCategoryCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiUnitCategoriesIdPut(id, updateUnitCategoryCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitCategoriesIdStatisticsGet(id: number, options?: any): AxiosPromise<CategoryStatisticsDto> {
            return localVarFp.apiUnitCategoriesIdStatisticsGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitCategoriesIdUnitsGet(id: number, options?: any): AxiosPromise<Array<UnitBriefDto>> {
            return localVarFp.apiUnitCategoriesIdUnitsGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateUnitCategoryCommand} [createUnitCategoryCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitCategoriesPost(createUnitCategoryCommand?: CreateUnitCategoryCommand, options?: any): AxiosPromise<number> {
            return localVarFp.apiUnitCategoriesPost(createUnitCategoryCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiUnitCategoriesGet operation in UnitCategoriesApi.
 * @export
 * @interface UnitCategoriesApiApiUnitCategoriesGetRequest
 */
export interface UnitCategoriesApiApiUnitCategoriesGetRequest {
    /**
     * 
     * @type {number}
     * @memberof UnitCategoriesApiApiUnitCategoriesGet
     */
    readonly pageNumber?: number

    /**
     * 
     * @type {number}
     * @memberof UnitCategoriesApiApiUnitCategoriesGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {number}
     * @memberof UnitCategoriesApiApiUnitCategoriesGet
     */
    readonly projectId?: number

    /**
     * 
     * @type {string}
     * @memberof UnitCategoriesApiApiUnitCategoriesGet
     */
    readonly searchTerm?: string

    /**
     * 
     * @type {boolean}
     * @memberof UnitCategoriesApiApiUnitCategoriesGet
     */
    readonly isActive?: boolean
}

/**
 * Request parameters for apiUnitCategoriesIdDelete operation in UnitCategoriesApi.
 * @export
 * @interface UnitCategoriesApiApiUnitCategoriesIdDeleteRequest
 */
export interface UnitCategoriesApiApiUnitCategoriesIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof UnitCategoriesApiApiUnitCategoriesIdDelete
     */
    readonly id: number
}

/**
 * Request parameters for apiUnitCategoriesIdFloorsGet operation in UnitCategoriesApi.
 * @export
 * @interface UnitCategoriesApiApiUnitCategoriesIdFloorsGetRequest
 */
export interface UnitCategoriesApiApiUnitCategoriesIdFloorsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof UnitCategoriesApiApiUnitCategoriesIdFloorsGet
     */
    readonly id: number
}

/**
 * Request parameters for apiUnitCategoriesIdGet operation in UnitCategoriesApi.
 * @export
 * @interface UnitCategoriesApiApiUnitCategoriesIdGetRequest
 */
export interface UnitCategoriesApiApiUnitCategoriesIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof UnitCategoriesApiApiUnitCategoriesIdGet
     */
    readonly id: number
}

/**
 * Request parameters for apiUnitCategoriesIdPut operation in UnitCategoriesApi.
 * @export
 * @interface UnitCategoriesApiApiUnitCategoriesIdPutRequest
 */
export interface UnitCategoriesApiApiUnitCategoriesIdPutRequest {
    /**
     * 
     * @type {number}
     * @memberof UnitCategoriesApiApiUnitCategoriesIdPut
     */
    readonly id: number

    /**
     * 
     * @type {UpdateUnitCategoryCommand}
     * @memberof UnitCategoriesApiApiUnitCategoriesIdPut
     */
    readonly updateUnitCategoryCommand?: UpdateUnitCategoryCommand
}

/**
 * Request parameters for apiUnitCategoriesIdStatisticsGet operation in UnitCategoriesApi.
 * @export
 * @interface UnitCategoriesApiApiUnitCategoriesIdStatisticsGetRequest
 */
export interface UnitCategoriesApiApiUnitCategoriesIdStatisticsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof UnitCategoriesApiApiUnitCategoriesIdStatisticsGet
     */
    readonly id: number
}

/**
 * Request parameters for apiUnitCategoriesIdUnitsGet operation in UnitCategoriesApi.
 * @export
 * @interface UnitCategoriesApiApiUnitCategoriesIdUnitsGetRequest
 */
export interface UnitCategoriesApiApiUnitCategoriesIdUnitsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof UnitCategoriesApiApiUnitCategoriesIdUnitsGet
     */
    readonly id: number
}

/**
 * Request parameters for apiUnitCategoriesPost operation in UnitCategoriesApi.
 * @export
 * @interface UnitCategoriesApiApiUnitCategoriesPostRequest
 */
export interface UnitCategoriesApiApiUnitCategoriesPostRequest {
    /**
     * 
     * @type {CreateUnitCategoryCommand}
     * @memberof UnitCategoriesApiApiUnitCategoriesPost
     */
    readonly createUnitCategoryCommand?: CreateUnitCategoryCommand
}

/**
 * UnitCategoriesApi - object-oriented interface
 * @export
 * @class UnitCategoriesApi
 * @extends {BaseAPI}
 */
export class UnitCategoriesApi extends BaseAPI {
    /**
     * 
     * @param {UnitCategoriesApiApiUnitCategoriesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitCategoriesApi
     */
    public apiUnitCategoriesGet(requestParameters: UnitCategoriesApiApiUnitCategoriesGetRequest = {}, options?: AxiosRequestConfig) {
        return UnitCategoriesApiFp(this.configuration).apiUnitCategoriesGet(requestParameters.pageNumber, requestParameters.pageSize, requestParameters.projectId, requestParameters.searchTerm, requestParameters.isActive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnitCategoriesApiApiUnitCategoriesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitCategoriesApi
     */
    public apiUnitCategoriesIdDelete(requestParameters: UnitCategoriesApiApiUnitCategoriesIdDeleteRequest, options?: AxiosRequestConfig) {
        return UnitCategoriesApiFp(this.configuration).apiUnitCategoriesIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnitCategoriesApiApiUnitCategoriesIdFloorsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitCategoriesApi
     */
    public apiUnitCategoriesIdFloorsGet(requestParameters: UnitCategoriesApiApiUnitCategoriesIdFloorsGetRequest, options?: AxiosRequestConfig) {
        return UnitCategoriesApiFp(this.configuration).apiUnitCategoriesIdFloorsGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnitCategoriesApiApiUnitCategoriesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitCategoriesApi
     */
    public apiUnitCategoriesIdGet(requestParameters: UnitCategoriesApiApiUnitCategoriesIdGetRequest, options?: AxiosRequestConfig) {
        return UnitCategoriesApiFp(this.configuration).apiUnitCategoriesIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnitCategoriesApiApiUnitCategoriesIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitCategoriesApi
     */
    public apiUnitCategoriesIdPut(requestParameters: UnitCategoriesApiApiUnitCategoriesIdPutRequest, options?: AxiosRequestConfig) {
        return UnitCategoriesApiFp(this.configuration).apiUnitCategoriesIdPut(requestParameters.id, requestParameters.updateUnitCategoryCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnitCategoriesApiApiUnitCategoriesIdStatisticsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitCategoriesApi
     */
    public apiUnitCategoriesIdStatisticsGet(requestParameters: UnitCategoriesApiApiUnitCategoriesIdStatisticsGetRequest, options?: AxiosRequestConfig) {
        return UnitCategoriesApiFp(this.configuration).apiUnitCategoriesIdStatisticsGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnitCategoriesApiApiUnitCategoriesIdUnitsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitCategoriesApi
     */
    public apiUnitCategoriesIdUnitsGet(requestParameters: UnitCategoriesApiApiUnitCategoriesIdUnitsGetRequest, options?: AxiosRequestConfig) {
        return UnitCategoriesApiFp(this.configuration).apiUnitCategoriesIdUnitsGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnitCategoriesApiApiUnitCategoriesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitCategoriesApi
     */
    public apiUnitCategoriesPost(requestParameters: UnitCategoriesApiApiUnitCategoriesPostRequest = {}, options?: AxiosRequestConfig) {
        return UnitCategoriesApiFp(this.configuration).apiUnitCategoriesPost(requestParameters.createUnitCategoryCommand, options).then((request) => request(this.axios, this.basePath));
    }
}
